module.exports = __webpack_public_path__ + "img/Bottone-Clienti.a4d71ffa.jpg";